const getClientByName = (name: string, clients: Record<string, string>) => {
  return { _id: clients[name], name: name }
}

const getClientById = (id: string, clients: Record<string, string>) => {
  const clientName = Object.keys(clients).find((name) => clients[name] === id)
  return { _id: id, name: clientName || '' }
}

export { getClientById, getClientByName }
